module.exports = __webpack_public_path__ + "static/media/epuletszarnyak-bontasa-veszelyes-hulladek-kezeles.b85d264d.jpg";